import React, { useState } from 'react';
import styled from 'styled-components';
import profilePhotoo from '../../../assets/images/logo.png';

const ChannelContainer = styled.div`
  padding: 30px;
  font-family: 'Ubuntu', sans-serif;
  color: #00ff00;
  background: rgba(0, 0, 0, 0.9);
  height: 100%;
  overflow-y: auto;
`;

const Header = styled.div`
  text-align: center;
  margin-bottom: 30px;
  border-bottom: 2px solid #ff0000;
  padding-bottom: 20px;
`;

const ChannelBanner = styled.div`
  background: linear-gradient(135deg,rgb(54, 2, 2),rgb(107, 6, 6));
  border-radius: 12px;
  padding: 30px;
  margin-bottom: 30px;
  text-align: center;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><circle cx="50" cy="50" r="2" fill="white" opacity="0.1"/></svg>') repeat;
    animation: float 20s linear infinite;
  }

  @keyframes float {
    0% { transform: translateY(0px); }
    100% { transform: translateY(-100px); }
  }
`;

const ChannelLogo = styled.img`
  width: 120px;
  height: 120px;
  border-radius: 50%;
  margin: 0 auto 20px;
  border: 4px solid #ffffff;
  box-shadow: 0 0 30px rgba(255, 0, 0, 0.5);
  position: relative;
  z-index: 1;
  object-fit: cover;
`;

const ChannelName = styled.h1`
  color: #ffffff;
  font-size: 2.5em;
  margin-bottom: 10px;
  position: relative;
  z-index: 1;
`;

const ChannelDescription = styled.p`
  color: #ffffff;
  font-size: 1.2em;
  margin-bottom: 20px;
  position: relative;
  z-index: 1;
`;

const SubscribeButton = styled.a`
  background: #ff0000;
  color: #ffffff;
  padding: 12px 30px;
  border-radius: 25px;
  text-decoration: none;
  font-weight: bold;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  transition: all 0.3s ease;
  position: relative;
  z-index: 1;
  border: 2px solid #ffffff;

  &:hover {
    background: #cc0000;
    transform: scale(1.05);
    box-shadow: 0 0 20px rgba(255, 0, 0, 0.6);
  }
`;

const ContentGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 30px;
  margin-bottom: 30px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const ContentSection = styled.div`
  background: rgba(255, 0, 0, 0.1);
  border: 1px solid rgba(255, 0, 0, 0.3);
  border-radius: 12px;
  padding: 25px;
`;

const SectionTitle = styled.h3`
  color: #ff0000;
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 1.3em;
`;

const VideoList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

const VideoItem = styled.div`
  background: rgba(0, 0, 0, 0.5);
  border: 1px solid rgba(255, 0, 0, 0.3);
  border-radius: 8px;
  padding: 15px;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background: rgba(255, 0, 0, 0.1);
    transform: translateX(5px);
    border-color: #ff0000;
  }
`;

const VideoTitle = styled.div`
  color: #ffffff;
  font-weight: bold;
  margin-bottom: 5px;
`;

const VideoDescription = styled.div`
  color: #cccccc;
  font-size: 12px;
  margin-bottom: 8px;
`;

const VideoTags = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
`;

const VideoTag = styled.span`
  background: rgba(255, 0, 0, 0.2);
  color: #ff0000;
  padding: 2px 8px;
  border-radius: 10px;
  font-size: 10px;
  border: 1px solid rgba(255, 0, 0, 0.3);
`;

const StatsSection = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
  margin-bottom: 30px;

  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;

const StatCard = styled.div`
  background: rgba(255, 0, 0, 0.1);
  border: 1px solid rgba(255, 0, 0, 0.3);
  border-radius: 8px;
  padding: 20px;
  text-align: center;
`;

const StatNumber = styled.div`
  font-size: 24px;
  font-weight: bold;
  color: #ff0000;
  margin-bottom: 5px;
`;

const StatLabel = styled.div`
  color: #cccccc;
  font-size: 12px;
`;

const SocialLinks = styled.div`
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-top: 30px;
`;

const SocialLink = styled.a`
  background: rgba(255, 0, 0, 0.2);
  border: 1px solid rgba(255, 0, 0, 0.3);
  border-radius: 50%;
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  font-size: 20px;
  transition: all 0.3s ease;

  &:hover {
    background: rgba(255, 0, 0, 0.3);
    transform: scale(1.1);
  }
`;

const YouTubeChannel: React.FC = () => {
  const [selectedCategory, setSelectedCategory] = useState('ctf');
  const profilePhoto = profilePhotoo ;


  return (
    <ChannelContainer>
      <Header>
        <ChannelName style={{ color: '#ff0000', fontSize: '2em' }}>
          📺 CYB3RFY YouTube Channel
        </ChannelName>
        <p>Cybersecurity Education & CTF Walkthroughs</p>
      </Header>

      <ChannelBanner>
        <ChannelLogo src={profilePhoto} alt="Mukul Joshi" />
        <ChannelName>CYB3RFY</ChannelName>
        <ChannelDescription>
          Your go-to channel for CTF writeups, TryHackMe walkthroughs, and cybersecurity tutorials
        </ChannelDescription>
        <SubscribeButton 
          href="https://www.youtube.com/@CYB3RFY" 
          target="_blank" 
          rel="noopener noreferrer"
        >
          🔔 Subscribe & Watch
        </SubscribeButton>
      </ChannelBanner>

  

      <ContentGrid>
        <ContentSection>
          <SectionTitle>
            🏁 CTF Walkthroughs
          </SectionTitle>
        
        </ContentSection>

        <ContentSection>
          <SectionTitle>
            🎯 TryHackMe Walkthroughs
          </SectionTitle>
          
        </ContentSection>
      </ContentGrid>

      <SocialLinks>
        <SocialLink 
          href="https://www.youtube.com/@CYB3RFY" 
          target="_blank" 
          rel="noopener noreferrer"
          title="YouTube Channel"
        >
          📺
        </SocialLink>
        <SocialLink 
          href="https://github.com/HeyMeMukul" 
          target="_blank" 
          rel="noopener noreferrer"
          title="GitHub"
        >
          🐙
        </SocialLink>
        <SocialLink 
          href="https://tryhackme.com/p/CYBERFY" 
          target="_blank" 
          rel="noopener noreferrer"
          title="TryHackMe"
        >
          🎯
        </SocialLink>
        <SocialLink 
          href="https://www.linkedin.com/in/memukuljoshi/" 
          target="_blank" 
          rel="noopener noreferrer"
          title="LinkedIn"
        >
          💼
        </SocialLink>
      </SocialLinks>
    </ChannelContainer>
  );
};

export default YouTubeChannel;
